module.exports = __webpack_public_path__ + "static/media/EKDWXR1.3a0bd9cf.png";